import * as lib from '~/dependencies';
import { colors, paddings } from '~/layout';

export const Container = lib.styled.div`
  display: flex;
  background-color: ${colors.white};
  flex-direction: column;
  position: relative;
  padding: ${paddings.alternative}px;
  padding-bottom: ${paddings.reset}px;
  padding-top: ${paddings.reset}px;
`;

export const DtmfContainer = lib.styled.div`
  z-index: 1000;
  position: absolute;
  width: 100%;
  bottom: 50px;
`;

export const Space = lib.styled.div`
  display: flex;
  height: ${props => props.height}px;
  min-height: ${props => props.height}px;
  width: 100%;
  flex: ${props => (props.complete ? 1 : 'none')}
`;

export const DottedDivisor = lib.styled.div`
  display: flex;
  height: 1px;
  width: 370px;
  margin: 0 auto;
  border-bottom: 1px dotted ${colors.lightGray06};
`;

export const Details = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .check-icon {
    font-size: 13px;
  }

  span {
    font-size: 11px;
    font-weight: 600;
    padding-left: 10px;

    &:first-child {
      padding-left: 0px;
    }
  }

  .otherInformations {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-left: 10px;
    flex-direction: column;

    span {
      font-size: 11px;
      font-weight: 600;
      padding-left: 0px!important;
    }
  }
`;

export const ActionsAdd = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding-right: 15px;
  padding-bottom: 10px;

  button {
    background-color: transparent;
    border: 0px;
    outline: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-direction: space-between;
    cursor: pointer;

    .addNotes {
      height: 13px;
      width: 18px;
      margin-right: 5px;
    }
  }
`;

export const RecentContainer = lib.styled.div`
  padding-left: 15px;
  padding-right: 15px;
`;
